import { apiInstances } from '../../../../libs';

const { get } = apiInstances.userInstance;

export default function getClouderStatus() {
  return get('/users/status');
}
